module.exports = __webpack_public_path__ + "static/media/table1.49d3de7f.jpg";